import React from 'react';
import { useNavigate } from 'react-router-dom';

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <Container className="flex-grow-1 d-flex align-items-center justify-content-center">
          <Row className="w-100">
            <Col>
              <div className="not-found-page text-center pt-5 pb-5">
                <h3 className="p-0 m-0">
                  Üzgünüz, aradığınız sayfaya ulaşılamıyor.
                </h3>
                <button
                  className="mt-4 btn btn-primary btn-lg rounded-pill px-5 shadow fw-bold"
                  onClick={() => navigate("/home", { replace: true })}
                >
                  Ana Sayfa
                </button>
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
